export enum GpPersonaType {
    NEEDS_COACHING,
    COACHING_REVIEW,
    IMPROVING_COACHING,
    SUCCESSFUL_COACHING,
    COACHING_RAMP,
    ON_TRACK,
}
